import React from "react";
import { NavLink } from "reactstrap";

const MobileNavbar = ({ items, onNavigate }) => {
  const [open, setOpen] = React.useState(() => new Set());

  const toggle = (id) => {
    setOpen((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const renderItems = (list, level = 0) =>
    list.map((item) => {
      const hasChildren = !!item.children?.length;
      const isOpen = open.has(item.id);

      if (!hasChildren) {
        return (
          <NavLink
            key={item.id}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onNavigate(item);
            }}
            style={{ paddingLeft: `${6 + level * 14}px` }}
            className="mobile-navlink"
          >
            {item.title}
          </NavLink>
        );
      }

      return (
        <div key={item.id} style={{ width: "full" }}>
          <NavLink
            href="#"
            onClick={(e) => {
              e.preventDefault();
              toggle(item.id);
            }}
            style={{ paddingLeft: `${6 + level * 14}px` }}
            className="mobile-navlink mobile-navlink--group"
          >
            <span>{item.title}</span>
            <span className={`mobile-navlink__chev ${isOpen ? "open" : ""}`}>
              ▾
            </span>
          </NavLink>

          {isOpen ? (
            <div className="mobile-navlink__children">
              {renderItems(item.children, level + 1)}
            </div>
          ) : null}
        </div>
      );
    });

  return <div className="mobile-menu">{renderItems(items)}</div>;
};

export default MobileNavbar;
